import { CodeNav } from '@clearkit/icons';
import { CKButton } from 'clearkit';
import { Link } from 'react-router-dom';

import { useConfigurationPageQuery } from '~/generated/graphql';
import { dataSources as dataSourceTypes } from '~/lib/configuration';

import {
  ImplementationCard,
  ImplementationCardWrapperProps,
} from '../ImplementationCard';
import { LoadingCard } from './LoadingCard';

export const ConnectClearbitTag = ({
  forceVisibility,
}: ImplementationCardWrapperProps) => {
  const { data, loading } = useConfigurationPageQuery();
  const isConnected = data?.account?.accountSetting?.dataSources?.includes(
    dataSourceTypes.clearbitjs,
  );

  if (loading) return <LoadingCard />;
  if (isConnected && !forceVisibility) return null;

  return (
    <ImplementationCard progress={isConnected ? 100 : 0}>
      <ImplementationCard.Heading>
        Connect your website
      </ImplementationCard.Heading>
      <ImplementationCard.Description>
        Reveal anonymous companies visiting on your website. By installing our
        script or using Google Tag Manager, we’ll reveal companies visiting your
        website and generate weekly visitor reports.
      </ImplementationCard.Description>
      <ImplementationCard.Footer>
        <CKButton
          as={Link}
          leftIcon={<CodeNav height={18} width={18} />}
          to="/settings/configuration/tagsjs"
          variant="bold"
          variantColor="green"
        >
          Set up Clearbit JS
        </CKButton>
        <CKButton href="/" variant="tertiary" variantColor="blue">
          Learn more
        </CKButton>
      </ImplementationCard.Footer>
    </ImplementationCard>
  );
};
